import * as React from "react";

function IcProductInsuranceEbillFill(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcProductInsuranceEbillFill"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M8 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H17C18.1046 3 19 3.89543 19 5V7M6.5 6.99999H14M6.5 11H9"
        stroke="#073E68"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 24C16 24 9.30796 23.1077 8.56648 13.7376C8.48796 12.7454 9.23183 11.8954 10.2171 11.7547L10.8249 11.6678C11.5918 11.5583 12.3103 11.2284 12.8933 10.7183L15.3415 8.57616C15.7185 8.24626 16.2814 8.24626 16.6585 8.57616L19.1067 10.7183C19.6896 11.2284 20.4082 11.5583 21.175 11.6678L21.7828 11.7547C22.7681 11.8954 23.512 12.7454 23.4335 13.7376C22.692 23.1077 16 24 16 24ZM19.7071 15.7071C20.0976 15.3166 20.0976 14.6834 19.7071 14.2929C19.3166 13.9023 18.6834 13.9023 18.2929 14.2929L15.5 17.0858L14.2071 15.7929C13.8166 15.4023 13.1834 15.4023 12.7929 15.7929C12.4023 16.1834 12.4023 16.8166 12.7929 17.2071L14.7929 19.2071C15.1834 19.5976 15.8166 19.5976 16.2071 19.2071L19.7071 15.7071Z"
        fill="#073E68"
      />
    </svg>
  );
}

export default IcProductInsuranceEbillFill;
